module.exports = __webpack_public_path__ + "static/media/banner-photo768.763d5af2.webp";